<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center ht-70">
        <i class="icon fa fa-globe" style=" font-size: 56px;"></i>
        <div class="mg-l-20">
          <h4>{{$t("express.海外物流管理")}}</h4>
        </div>
      </div>
      <div class="tx-right">
        <!--<button class=" btn btn-success" @click="openEditShipping()">添加物流渠道</button>-->
        <router-link class="mg-r-15 btn btn-success" target="_blank" :to="'/create-shipping'">{{$t("express.添加物流渠道")}}</router-link>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30">
      <div class="clear-key">
        <a v-show="filterProp.logistics" href="javascript:;" class=" mg-r-15" @click="clearKey('logistics')">
          {{$t("express.物流名称：")}}
          <span class="mg-r-10">{{filterProp.logistics}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="filterProp.countryCode" href="javascript:;" class=" mg-r-15" @click="clearKey('countryCode')">
          {{$t("express.国家：")}}
          <span class="mg-r-10">{{countrysName(filterProp.countryCode)}} {{filterProp.countryCode}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="filterProp.status" href="javascript:;" class=" mg-r-15" @click="clearKey('status')">
          {{$t("express.状态：")}}
          <span class="mg-r-10">{{filterProp.status == 1 ? $t('express.启用') : $t('express.停用')}}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["countrys", "filterProp"],
  methods:{
    countrysName(code){
      let name = '';
      this.countrys.forEach(c => {
        c.sub.forEach(item => {
          if(item.code2 == code){
            name = item.nameCN;
          }
        });
      })
      return name;
    },
    clearKey(type){
      this.$emit('clearKey', type)
    },
    openEditShipping(){
      this.$emit('openEditShipping')
    }
  }
}
</script>
